module.exports = __webpack_public_path__ + "static/media/logow.55a617be.png";